import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import INFTProperties, { IBaseNFTAttributes } from '../../models/INFTProperties'
import { ICryptoDappersCard } from '../../nftFormats/CryptoDapper/Card/ICryptoDappersCard'
import { CryptoDappersTierList } from '../../nftFormats/CryptoDapper/CryptoDappersTierList'
import BaseDetail from './BaseDetail'


export default function CryptoDappersDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<ICryptoDappersCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)
  const tokenName = `${collection?.name} #${detailTokenItem ? detailTokenItem.token_id : 0}`

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => {
        let newProps = {
          key: item.trait_type,
          value: item.value,
          show: true,
          isUrl: false
        }

        if (item.trait_type === 'Tier') {
          newProps = {
            ...newProps,
            value: CryptoDappersTierList[item.value]
          }
        }

        return newProps
      })
    }

    return result
  }

  function getNFTDescription() {
    return (
      <div>
        What is a CryptoDapper?
        <p slot="content" className="svelte-136eskq">
          The CryptoDapper, or <span>Dapper</span> for short, is an original, yield-generating{' '}
          <span style={{ marginRight: '0.5rem' }}>ERC-721 NFT</span>
          that exists on the <span>Avalanche C-Chain</span>. There are <span>2500</span> Dappers in existence. They are
          apt to don <span style={{ marginRight: '0.5rem' }}>fancy costumes</span>, gorge on <span>fruit bowls</span>,
          and summon elements of Earth, Water, and Fire to protect themselves from <span>forces of evil</span>.
        </p>
      </div>
    )
  }

  return (
    <BaseDetail {...props} tokenItemName={tokenName} properites={getNFTProperties()} description={getNFTDescription()}>
      {detailTokenItem ? (
        <img className="crypto-companions-image" src={detailTokenItem.image} alt={tokenName} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
